// /users 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 3개를 이 배열 하나로 대체한다. field 키 / operator 는 기존과 100% 동일.

import type { SearchFieldConfig } from "components/list";

export const usersSearchFields: SearchFieldConfig[] = [
  { name: "loginId", label: "로그인아이디에서 검색", type: "text", operator: "contains", width: 200 },
  { name: "nickName", label: "닉네임에서 검색", type: "text", operator: "contains", width: 200 },
  { name: "phoneNumber", label: "전화번호에서 검색", type: "text", operator: "contains", width: 200 },
];
